package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class CreditCardsEnum(
    val cardNameValue: String,
    val fromAmount: String,
    val variable: String,
    val receiptCopy: String
) {
    CARD_1(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    ),
    CARD_2(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    ),
    CARD_3(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    ),
    CARD_4(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    ),
    CARD_5(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    ),
    CARD_6(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    ),
    CARD_7(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    ),
    CARD_8(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    ),
    CARD_9(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    ),
    CARD_10(
        cardNameValue = "",
        fromAmount = "",
        variable = "",
        receiptCopy = ""
    );

    val cardNameTitle: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                CARD_1 -> strings.name1
                CARD_2 -> strings.name2
                CARD_3 -> strings.name3
                CARD_4 -> strings.name4
                CARD_5 -> strings.name5
                CARD_6 -> strings.name6
                CARD_7 -> strings.name7
                CARD_8 -> strings.name8
                CARD_9 -> strings.name9
                CARD_10 -> strings.name10
            }
        }
}